import { render, staticRenderFns } from "./UserCenterView.vue?vue&type=template&id=133427c1&scoped=true"
import script from "./UserCenterView.vue?vue&type=script&lang=js"
export * from "./UserCenterView.vue?vue&type=script&lang=js"
import style0 from "./UserCenterView.vue?vue&type=style&index=0&id=133427c1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133427c1",
  null
  
)

export default component.exports